import { IOverdueRemindersHook } from '@models';
import { useStore } from '@stores';
import { useEffect } from 'react';

export const useOverdueReminderCount = (vin: string | undefined): IOverdueRemindersHook => {
  const { reminderStore } = useStore();
  const { overdueLoading, overdueCount } = reminderStore;

  useEffect(() => {
    vin && reminderStore.getOverdueReminderCount(vin);
  }, [reminderStore, vin]);

  return {
    loading: overdueLoading,
    overdueCount: overdueCount,
  };
};
